var map = {
  "./cs.json": [
    "mq",
    [
      "ko"
    ]
  ],
  "./en.json": [
    "lp",
    [
      "r3"
    ]
  ],
  "./pl.json": [
    "TP",
    [
      "h4"
    ]
  ],
  "./ru.json": [
    "Pr",
    [
      "xp"
    ]
  ],
  "./tr.json": [
    "lL",
    [
      "vu"
    ]
  ],
  "./ja.json": [
    "d5",
    [
      "3l"
    ]
  ],
  "./zh.json": [
    "qF",
    [
      "o9p"
    ]
  ],
  "./pt-br.json": [
    "Fx",
    [
      "be5"
    ]
  ],
  "./de.json": [
    "o1z",
    [
      "e7v"
    ]
  ],
  "./es.json": [
    "S8D",
    [
      "suv"
    ]
  ],
  "./fr.json": [
    "ft",
    [
      "9e"
    ]
  ],
  "./it.json": [
    "iyS",
    [
      "gid"
    ]
  ],
  "./ko.json": [
    "vTX",
    [
      "x4"
    ]
  ],
  "./pt.json": [
    "R8B",
    [
      30
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Ej";
module.exports = __rspack_async_context;
